import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import {
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
} from './ReactiveState.mjs';
import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance27cl4xxdoduaj as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import {
  Companion_getInstance3bjjjd8igr9ok as Companion_getInstance_0,
  Reactive1jy75v4li6ldv as Reactive,
} from './coreInterfaces.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  ensureActivem48bojk66pw0 as ensureActive,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from './abstracts.mjs';
import { RawReactive253xb355brtjj as RawReactive } from './signals.mjs';
import { TypedReactiveContextwc1z7epz7cib as TypedReactiveContext } from '../context/ReactiveContext.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function remember(coroutineContext, useLastWhileLoading, deactivationDelay, reentrancyLimit, action) {
  coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().Unconfined_1 : coroutineContext;
  useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
  deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
  reentrancyLimit = reentrancyLimit === VOID ? 0 : reentrancyLimit;
  return Remember().new_com_lightningkite_reactive_core_Remember_5il1gz_k$(coroutineContext, useLastWhileLoading, deactivationDelay, reentrancyLimit, action);
}
function shutdown($this) {
  var tmp0_safe_receiver = $this.remover_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  $this.remover_1 = null;
  $this.scope_1.cancel_2l89ey_k$();
  $this.job_1.cancel$default_8haxne_k$();
  $this.job_1 = SupervisorJob();
  $this.shuttingDown_1 = null;
  $this.reported_1.set_state_wnfcx0_k$(Companion_getInstance().notActive_1);
}
var Remember$restOfContext$$inlined$CoroutineExceptionHandler$1Class;
function Remember$restOfContext$$inlined$CoroutineExceptionHandler$1() {
  if (Remember$restOfContext$$inlined$CoroutineExceptionHandler$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor() {
        super(Key_instance);
      }
      handleException_e679jj_k$(context, exception) {
        if (!(exception instanceof CancellationException())) {
          Companion_getInstance_0().reportException_1(exception);
        }
        return Unit_instance;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Element()]);
    Remember$restOfContext$$inlined$CoroutineExceptionHandler$1Class = $;
  }
  return Remember$restOfContext$$inlined$CoroutineExceptionHandler$1Class;
}
function Remember$activate$slambda($it, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* $it.join_o20dar_k$($completion);
    this$0.scope_1.startCalculation_tphsqx_k$();
    var tmp = this$0;
    tmp.remover_1 = this$0.scope_1.addListener_6y9mct_k$(() => {
      this$0.invokeAllListeners_uusj2y_k$();
      return Unit_instance;
    });
    return Unit_instance;
  }), 1);
}
function Remember$deactivate$slambda$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    shutdown(this$0);
    return Unit_instance;
  }), 1);
}
function Remember$deactivate$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(this$0.deactivationDelay_1, $completion);
    ensureActive($this$launch);
    var tmp = this$0;
    var tmp_0 = CoroutineScope(this$0.incomingCoroutineContext_1);
    tmp.shuttingDown_1 = launch(tmp_0, VOID, VOID, Remember$deactivate$slambda$slambda(this$0));
    this$0.deactivating_1 = null;
    return Unit_instance;
  }), 1);
}
var RememberClass;
function Remember() {
  if (RememberClass === VOID) {
    class $ extends BaseListenable() {
      constructor(incomingCoroutineContext, useLastWhileLoading, deactivationDelay, reentrancyLimit, action) {
        return new.target.new_com_lightningkite_reactive_core_Remember_5il1gz_k$(incomingCoroutineContext, useLastWhileLoading, deactivationDelay, reentrancyLimit, action);
      }
      static new_com_lightningkite_reactive_core_Remember_5il1gz_k$(incomingCoroutineContext, useLastWhileLoading, deactivationDelay, reentrancyLimit, action) {
        incomingCoroutineContext = incomingCoroutineContext === VOID ? Dispatchers_getInstance().Unconfined_1 : incomingCoroutineContext;
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
        reentrancyLimit = reentrancyLimit === VOID ? 0 : reentrancyLimit;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$();
        $this.incomingCoroutineContext_1 = incomingCoroutineContext;
        $this.useLastWhileLoading_1 = useLastWhileLoading;
        $this.deactivationDelay_1 = deactivationDelay;
        $this.action_1 = action;
        $this.job_1 = SupervisorJob();
        var tmp = $this;
        // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
        var tmp$ret$0 = new (Remember$restOfContext$$inlined$CoroutineExceptionHandler$1())();
        tmp.restOfContext_1 = $this.incomingCoroutineContext_1.plus_s13ygv_k$(tmp$ret$0);
        $this.reported_1 = RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(Companion_getInstance().notActive_1);
        $this.scope_1 = new (TypedReactiveContext())($this, $this.useLastWhileLoading_1, reentrancyLimit, $this.reported_1, $this.action_1);
        $this.deactivating_1 = null;
        $this.remover_1 = null;
        $this.shuttingDown_1 = null;
        return $this;
      }
      get_coroutineContext_115oqo_k$() {
        return this.restOfContext_1.plus_s13ygv_k$(this.job_1);
      }
      get_state_wc71uu_k$() {
        return this.reported_1.get_state_wc71uu_k$();
      }
      activate_yijg9v_k$() {
        if (!(this.deactivating_1 == null)) {
          var tmp0_safe_receiver = this.deactivating_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cancel$default_8haxne_k$();
          }
          this.deactivating_1 = null;
          return Unit_instance;
        }
        var tmp;
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.notActive' call
        var this_0 = this.reported_1.get_state_wc71uu_k$();
        if (equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
          tmp = !this.useLastWhileLoading_1;
        } else {
          tmp = false;
        }
        if (tmp) {
          this.reported_1.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
        }
        var tmp1_safe_receiver = this.shuttingDown_1;
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_1 = CoroutineScope(this.incomingCoroutineContext_1);
          tmp_0 = launch(tmp_1, VOID, VOID, Remember$activate$slambda(tmp1_safe_receiver, this));
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var $this$run = this;
          $this$run.scope_1.startCalculation_tphsqx_k$();
          var tmp_2 = $this$run;
          tmp_2.remover_1 = $this$run.scope_1.addListener_6y9mct_k$(() => {
            $this$run.invokeAllListeners_uusj2y_k$();
            return Unit_instance;
          });
        }
      }
      deactivate_pmdz1g_k$() {
        var tmp = this.deactivationDelay_1;
        if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
          if (!(this.deactivating_1 == null))
            return Unit_instance;
          var tmp_0 = this;
          tmp_0.deactivating_1 = launch(this, VOID, VOID, Remember$deactivate$slambda(this));
        } else {
          shutdown(this);
        }
      }
    }
    initMetadataForClass($, 'Remember', VOID, VOID, [Reactive()]);
    RememberClass = $;
  }
  return RememberClass;
}
//region block: exports
export {
  Remember as Rememberkif8023snbmn,
  remember as remember2m0mx1b5ra75q,
};
//endregion

//# sourceMappingURL=Remember.mjs.map
